import React, { useMemo } from 'react';
import CustomTable from '../../../tables/CustomTable';
import { NavReconPosition } from '../../../../api/rs-hg/nav-recon/types';
import {
  NavReconPositionTableRow,
  getNavReconPositionDetailColumns,
} from './navReconPositionsColumns';
import { NavReconPositionThresholds } from '../../../../api/rs-hg/nav-recon/types';
import { useNavReconPositionDetailTableStyles } from './navReconPositionDetailTableStyles';

interface NavReconPositionsDetailPanelProps {
  rowData: NavReconPositionTableRow;
  thresholds: NavReconPositionThresholds;
}

const NavReconPositionsDetailPanel: React.FC<
  NavReconPositionsDetailPanelProps
> = ({ rowData, thresholds }) => {
  const classes = useNavReconPositionDetailTableStyles();
  const columns = useMemo(
    () => getNavReconPositionDetailColumns(thresholds),
    [thresholds],
  );

  const { csvFields, fieldsMap } = useMemo(() => {
    const exportable = columns.filter((col) => col.field);
    return {
      csvFields: exportable.map((col) => col.field as string),
      fieldsMap: exportable
        .filter((col) => col.title)
        .map((col) => ({
          key: col.field as string,
          label: col.title as string,
        })),
    };
  }, [columns]);

  const exportFileName = `nav-recon-positions-${rowData.asset_class
    .toLowerCase()
    .replace(/\s+/g, '-')}`;

  return (
    <div className={classes.detailContent}>
      <CustomTable<NavReconPosition>
        id={`nav-recon-positions-detail-${exportFileName}`}
        title={`${rowData.asset_class} positions`}
        tableRootStyles={classes.detailTableRoot}
        showToolbar
        columns={columns}
        csvFields={csvFields}
        fieldsMap={fieldsMap}
        data={rowData.positions}
        exportFileName={exportFileName}
        options={{
          paging: false,
          search: true,
          sorting: true,
          exportButton: true,
          raptorExport: true,
        }}
        emptyDataSourceMessage="No positions for this asset class."
      />
    </div>
  );
};

export default NavReconPositionsDetailPanel;
